import angular from 'angular';
import { mapValues, pickBy } from 'lodash';

const MAX_FLOORS = 3;

// Helper method to translate Dwellings' pool field to the seller input options.
// For now we have to check for both Private and true until we port the pool
// field to true / false only.
function translatePool(pool) {
  if (pool === 'Private' || pool === true)
    return 'in_ground';
  if (pool === 'None' || pool === false)
    return 'none';
}

module.exports = angular.module('market.services.mls-parser', [])
.factory('MLSParser', function() {
  return {
    makePrefills: (rawMlsInfo) => {
      if (!rawMlsInfo) return {};
      let makeMlsPrefill = value => value && { value, source: 'MLS' };

      let castInt = value => parseInt(value, 10) || null;
      let castFloat = value => parseFloat(value, 10) || null;

      let floors = castInt(rawMlsInfo.exterior_stories);
      return pickBy(mapValues({
        'home.bathrooms': castFloat(rawMlsInfo.bathrooms),
        'home.bedrooms': castInt(rawMlsInfo.bedrooms),
        'home.exterior_stories': floors <= MAX_FLOORS ? floors : null,
        'home.garage_spaces': castInt(rawMlsInfo.garage_spaces),
        'home.pool_type': translatePool(rawMlsInfo.pool),
        'home.above_grade_sq_ft': castInt(rawMlsInfo.sq_ft),
        'home.year_built': castInt(rawMlsInfo.year_built)
      }, makeMlsPrefill));
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/mls-parser.js
 **/